/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/ApprovalMatrixTable.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Approval Matrix
 *
 * PURPOSE:
 * Display Approval Matrix Rules
 *
 * RESPONSIBILITY:
 * • Presentational Component
 * • No Business Logic
 * • No API Calls
 ******************************************************************************/

import React from "react";

export default function ApprovalMatrixTable({

    loading,

    approvalMatrices = [],

    onEdit,

    onDelete,

    onActivate,

    onDeactivate,

}) {

    return (

        <div className="card shadow-sm">

            <div className="card-body p-0">

                <div className="table-responsive">

                    <table className="table table-hover table-bordered mb-0">

                        <thead className="table-light">

                            <tr>

                                <th>Workflow</th>

                                <th>Department</th>

                                <th>Policy</th>

                                <th>Category</th>

                                <th>Type</th>

                                <th>Currency</th>

                                <th width="170">
                                    Amount Range
                                </th>

                                <th width="80">
                                    Priority
                                </th>

                                <th width="90">
                                    Status
                                </th>

                                <th width="260">
                                    Actions
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {loading && (

                                <tr>

                                    <td
                                        colSpan="10"
                                        className="text-center p-4"
                                    >

                                        Loading...

                                    </td>

                                </tr>

                            )}

                            {!loading &&
                                approvalMatrices.length === 0 && (

                                <tr>

                                    <td
                                        colSpan="10"
                                        className="text-center p-4"
                                    >

                                        No Approval Matrix rules found.

                                    </td>

                                </tr>

                            )}

                            {!loading &&
                                approvalMatrices.map((rule) => (

                                <tr
                                    key={rule.approval_matrix_id}
                                >

                                    <td>

                                        {rule.workflow_name ||
                                            rule.workflow_id}

                                    </td>

                                    <td>

                                        {rule.department_name ||
                                            "All"}

                                    </td>

                                    <td>

                                        {rule.expense_policy_name ||
                                            "All"}

                                    </td>

                                    <td>

                                        {rule.expense_category_name ||
                                            "All"}

                                    </td>

                                    <td>

                                        {rule.expense_type_name ||
                                            "All"}

                                    </td>

                                    <td>

                                        {rule.currency_code ||
                                            "All"}

                                    </td>

                                    <td>

                                        {Number(
                                            rule.minimum_amount || 0
                                        ).toLocaleString()}

                                        {" - "}

                                        {

                                            rule.maximum_amount !== null &&
                                            rule.maximum_amount !== undefined

                                                ? Number(
                                                    rule.maximum_amount
                                                ).toLocaleString()

                                                : "Unlimited"

                                        }

                                    </td>

                                    <td>

                                        {rule.priority}

                                    </td>

                                    <td>

                                        {rule.is_active ? (

                                            <span className="badge bg-success">

                                                Active

                                            </span>

                                        ) : (

                                            <span className="badge bg-danger">

                                                Inactive

                                            </span>

                                        )}

                                    </td>

                                    <td>

                                        <button

                                            className="btn btn-sm btn-warning me-1"

                                            onClick={() =>
                                                onEdit(rule)
                                            }

                                        >

                                            Edit

                                        </button>

                                        {rule.is_active ? (

                                            <button

                                                className="btn btn-sm btn-secondary me-1"

                                                onClick={() =>
                                                    onDeactivate(rule)
                                                }

                                            >

                                                Deactivate

                                            </button>

                                        ) : (

                                            <button

                                                className="btn btn-sm btn-success me-1"

                                                onClick={() =>
                                                    onActivate(rule)
                                                }

                                            >

                                                Activate

                                            </button>

                                        )}

                                        <button

                                            className="btn btn-sm btn-danger"

                                            onClick={() =>
                                                onDelete(rule)
                                            }

                                        >

                                            Delete

                                        </button>

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    );

}